import { render, staticRenderFns } from "./ChartSalesTotal.vue?vue&type=template&id=53b28200&"
import script from "./ChartSalesTotal.vue?vue&type=script&lang=js&"
export * from "./ChartSalesTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports